export default __webpack_public_path__ + "static/benefit2-c1cd27db7097f2255faaac92419f5eb1.svg";